import { defineStore } from 'pinia';

export default defineStore({
  id: 'session',
  state: () => ({
    token: null,
    HUBSettings: {
      runningModule: {},
      currentLearningType: {},
      currentTheme: {},
      currentClient: {},
      currentFunction: {},
      levelUp: null,
    },
  }),
  getters: {
    loginUser(state) {
      if (!state.token) {
        return { team: {} };
      }

      const [, payloadTokenPart] = state.token.split('.');
      const fullPayloadData = JSON.parse(window.atob(payloadTokenPart));
      const loginData = (({ iat, exp, ...payloadData }) => payloadData)(fullPayloadData);
      const { teams, ...loginUser } = loginData;

      loginUser.team = {};

      if (teams && teams.length > 0) {
        loginUser.team.id = teams[0].team_id;
        loginUser.team.name = teams[0].team_name;
      }

      return loginUser;
    },
  },
  actions: {
    setToken(token) {
      this.token = token;

      if (!this.token) {
        localStorage.removeItem('hub-facilitator-portal-token');
      }

      localStorage.setItem('hub-facilitator-portal-token', this.token);
    },

    updateAuthToken({ newToken }) {
      this.setToken(newToken);
    },

    /**
     * Set an object as new HUBSettings
     */
    setHUBSettings(HUBSettings) {
      this.HUBSettings = HUBSettings;
    },

    /**
     * Add a key/value object to user settings object
     */
    setHUBSettingItems(items) {
      this.HUBSettings = { ...this.HUBSettings, ...items };
    },

    resetHUBSettings() {
      this.setHUBSettings({
        runningModule: {},
        currentLearningType: {},
        currentTheme: {},
        currentClient: {},
        currentFunction: {},
        levelUp: null,
      });
    },

    createSession({ token, settings }) {
      this.setToken(token);
      this.setHUBSettings(settings);
    },

    clearSession() {
      this.setToken(null);
      this.setHUBSettings(null);
    },
  },
});
